const datadogLogger = require('@datadog/browser-logs');
const guidUtil = require('../guid/guidUtil');

module.exports.createTracingContext = function(url, verb)
{
    var tracingContext = {};
    tracingContext.traceId = guidUtil.generateGuid();

    try
    {
        var currentContext = datadogLogger.datadogLogs.getGlobalContext();
        tracingContext.originService = "RMS.APP.POS";
        tracingContext.originEnv = currentContext.env;
        tracingContext.originShellType = currentContext.shellType;
        tracingContext.originRenderingMode = currentContext.renderingMode;
        tracingContext.originVersion = currentContext.version;
        tracingContext.originSessionId = currentContext.sessionId;
        
        tracingContext.originFranchisorId = currentContext.franchisorId;
        tracingContext.originFranchisorCode = currentContext.franchisorCode;
        tracingContext.originFranchisorName = currentContext.franchisorName;
        tracingContext.originFranchiseeId = currentContext.franchiseeId;
        tracingContext.originFranchiseeCode = currentContext.franchiseeCode;
        tracingContext.originFranchiseeName = currentContext.franchiseeName;
        tracingContext.originPropertyId = currentContext.propertyId;
        tracingContext.originPropertyCode = currentContext.propertyCode;
        tracingContext.originPropertyName = currentContext.propertyName;

        tracingContext.terminalCode = currentContext.terminalCode;
    
        tracingContext.originUrl = url;
        tracingContext.originVerb = verb;

        inferModuleAndAction(tracingContext, url, verb);
    }
    catch(error)
    {

    }
    return tracingContext;
}

function inferModuleAndAction(tracingContext, url, verb)
{
    tracingContext.originModule = url;
    tracingContext.originAction = verb;
}
